import { twMerge } from "tailwind-merge"
import { IconChevronDown } from "./Icon"
import { ReactNode } from "react"

export const Select = ({
  label,
  options,
  value,
  onChange,
  className,
  innerClassName,
}: {
  label?: string
  options: { value?: string; label: ReactNode }[]
  value?: string
  onChange?: (value: any) => void
  className?: string
  innerClassName?: string
}) => {
  return (
    <div className={twMerge("flex flex-col gap-1 relative text-white/60 shrink-0", className)}>
      {label && (
        <label className="type-label-l" htmlFor={label}>
          {label}
        </label>
      )}
      <div className="relative">
        <select
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          className={twMerge(
            "!w-full !border !border-white/20 placeholder:text-white/20 rounded-sm px-4 py-3 type-text-input !pl-4 !mr-7 md:!mr-6 !appearance-none !bg-none bg-black",
            innerClassName,
          )}
        >
          {options.map((option, ox) => (
            <option key={`${option.value}${ox}`} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <div className="absolute right-2 top-1/2 -translate-y-1/2 w-[1.4em] h-[1.4em] pointer-events-none">
          <IconChevronDown />
        </div>
      </div>
    </div>
  )
}
